module.exports = __webpack_public_path__ + "static/turtle-creek-house36-2562e1a071fdd650544b154712a68621.jpg";